export const GET_MENTIONS = "GET_MENTIONS"
export const GET_MENTIONS_FAIL = "GET_MENTIONS_FAIL"
export const GET_MENTIONS_SUCCESS = "GET_MENTIONS_SUCCESS"

export const ADD_NEW_MENTION = "ADD_NEW_MENTION"
export const ADD_MENTION_SUCCESS = "ADD_MENTION_SUCCESS"
export const ADD_MENTION_FAIL = "ADD_MENTION_FAIL"

export const UPDATE_MENTION = "UPDATE_MENTION"
export const UPDATE_MENTION_SUCCESS = "UPDATE_MENTION_SUCCESS"
export const UPDATE_MENTION_FAIL = "UPDATE_MENTION_FAIL"

export const DELETE_MENTION = "DELETE_MENTION"
export const DELETE_MENTION_SUCCESS = "DELETE_MENTION_SUCCESS"
export const DELETE_MENTION_FAIL = "DELETE_MENTION_FAIL"





